import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx'
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import { Http } from "@angular/http";
import { Config } from "app/config/config";
//import config from "../config/config.json";

@Injectable()
export class ConfigService {
    private EnseigneKey:string = "";
    private BaseUrlWebApi:string = "";
    private BaseRouterPath:string = "";
    private flagEnseigneKey:boolean = false;
    private flagBaseUrlWebApi:boolean = false;
    private flagBaseRouterPath:boolean = false;
    
    constructor(private _http:Http, private config:Config) {
        
        this.load();
    }
    public load() {
        
        //this.config.load();

        this.setEnseigne();

        this.setBaseUrlWebApi();

        this.setBaseRouterPath();
        
    }

    setEnseigne() {
        let enseigneKey = this.config.get("enseigneKey");
        if (enseigneKey != null) {
            this.EnseigneKey = enseigneKey;
            this.flagEnseigneKey = true;
        }
    }

    setBaseUrlWebApi() {
        let baseUrlWebApi = this.config.get("baseUrlWebApi");
        if (baseUrlWebApi != null) {
            this.BaseUrlWebApi = baseUrlWebApi;
            this.flagBaseUrlWebApi = true;
        }       
    }

    setBaseRouterPath() {
        let baseRouterPath = this.config.get("baseRouterPath");
        if (baseRouterPath != null) {
            this.BaseRouterPath = baseRouterPath;
            this.flagBaseRouterPath = true;
        }       
    }
    public getEnseigneKey(){

        if (! this.flagEnseigneKey) {
            this.setEnseigne();
        }

        return this.EnseigneKey;
    }

    public getBaseUrlWebApi(){

        if (! this.flagBaseUrlWebApi) {
            this.setBaseUrlWebApi();
        }

        return  this.BaseUrlWebApi;
    }

    public getBaseRouterPath(){

        if (! this.flagBaseRouterPath) {
            this.setBaseRouterPath();
        }

        return  this.BaseRouterPath;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/config.service.ts